export default __webpack_public_path__ + "static/23-cef032a4b2b50e4ebdefa6a39c3a9f7d.png";